<template>
  <div class="order-refund-select-items flex flex-auto flex-col">
    <div class="info">
      <div class="title">
        Select items you want to refund
      </div>
      <div class="description">
        Please select the items you would like to refund and add a refund
        reason.
      </div>
    </div>
    <RefundableOrderItemView
        v-for="item in selections"
        :key="item.id"
        :is-selected="item.selected"
        :selected-reason="item.reason"
        :selected.sync="item.selected"
        :reason.sync="item.reason"
        :is-valid-refund.sync="item.isValidRefund"
        :refund-amount.sync="item.refundAmount"
        :refund-type.sync="item.refundType"
        :refund-reasons="refundReasons"
        v-bind="item" />
    <RefundShippingCard
        :shipping-total="shippingTotal"
        :refund-shipping.sync="refundShipping" />
  </div>
</template>

<script>
import RefundableOrderItemView from "./RefundableOrderItemView.vue";
import RefundShippingCard from "./RefundShippingCard.vue";
import { cloneDeep } from "lodash";

export default {
  name: "RefundSelectItems",
  components: {
    RefundableOrderItemView,
    RefundShippingCard,
  },
  props: {
    refundReasons: {
      type: Array,
      default() {
        return [];
      },
    },
    refundableItems: {
      type: Array,
      default() {
        return [];
      },
    },
    alreadySelected: {
      type: Array,
      default() {
        return [];
      },
    },
    shippingTotal: {
      type: Number,
      default: 0,
    },
    refundShipping: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selections: [],
    };
  },
  watch: {
    selections: {
      handler: function (value) {
        this.$emit("get-selected-items-for-refund", value);
      },
      deep: true,
    },
    refundShipping: {
      handler: function (value) {
        this.$emit("update:refundShipping", value);
      },
      deep: true,
    },
    alreadySelected: {
      handler: function (newVal) {
        if (newVal.length > 0) {
          this.selections = newVal;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.alreadySelected.length > 0) {
      this.selections = this.alreadySelected;
    } else {
      let selections = cloneDeep(this.refundableItems);
      for (const key in selections) {
        selections[key].selected = false;
        selections[key].reason = null;
        selections[key].isValidRefund = false;
        selections[key].refundAmount = 0;
        selections[key].refundType = "partial";
      }
      this.selections = selections;
    }
  },
};
</script>

<style scoped>
.order-refund-select-items {
  gap: 8px;
  .title {
    width: 532px;
    height: 36px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
  }
  .description {
    width: 532px;
    height: 48px;
    font-family: "Equip";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
    word-break: break-word;
  }
  .info {
    margin-bottom: 15px;
  }
}
</style>
